import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from '@lib/auth/data-access';
import { DialogService } from 'primeng/dynamicdialog';
import { AppInsightsLoggingService, BroadcastService } from '@lib/shared/data-access';
import { BroadcastChannelType } from '@lib/shared/models';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { InactivityComponent } from '@lib/inactivity/feature-inactivity';
import { AppThemeComponent } from './shell/themes/app.themes.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    ToastModule,
    InactivityComponent,
    RouterOutlet,
    AppThemeComponent
  ],
  providers: [DialogService],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  public title = 'administration-center';
  public isIframe: boolean = false;

  public authService = inject(AuthService);
  private broadcastService = inject(BroadcastService);
  private swUpdate = inject(SwUpdate);
  private messageService = inject(MessageService);
  public router = inject(Router);
  private destroyRef = inject(DestroyRef);

  //Need to inject so the constructor runs. This will initialize the AppInsights instance.
  private appInsightsLoggingService = inject(AppInsightsLoggingService);


    /**
  * TODO: Remove this when https://github.com/primefaces/primeng/issues/19213 is fixed
  */
  private clearMenuPopups(): void {
      const menuElements = document.querySelectorAll('body > [name="p-anchored-overlay"]');
      menuElements.forEach((node) => {
      node.remove();
      });
  }

  ngOnInit() {
    this.router.events
    .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
    )
    .subscribe(() => {
        this.clearMenuPopups();
    });

    this.isIframe = window !== window.parent && !window.opener;
    this.authService.setIsInitialLoginLoad(false);

    if (window.location.href.includes('/error-unauthorized')) {
      this.authService.setIsUnauthorized(true);
    }

    this.authService.initAuth0();

    // Listen for refetch auth message. If received, refetch the auth token and redirect to the respective landing page
    this.broadcastService.addMessageListener(BroadcastChannelType.TokenRefreshAndReload, () => {
      console.log('TODO: Handle TokenRefreshAndReload Broadcast');
    });

    this.broadcastService.addMessageListener(BroadcastChannelType.TokenRefresh, () => {
      console.log('TODO: Handle TokenRefresh Broadcast');
    });

    this.broadcastService.addMessageListener(BroadcastChannelType.Logout, () => {
      this.authService.logout();
    });

    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY')
        )
        .subscribe(() => {
          // Show a toast when a new version is available
          this.messageService.add({
            severity: 'warn',
            key: 'new-version',
            summary: 'New Version Available',
            detail: 'Please refresh your browser to get the latest version of the app.',
            sticky: true,  // Keep the toast until user interacts
            data: { reload: true }
          });
        });
    }
  }
}
